export var FlushMode = /*#__PURE__*/ function(FlushMode) {
    FlushMode[FlushMode["Manual"] = 0] = "Manual";
    FlushMode[FlushMode["Timed"] = 1] = "Timed";
    return FlushMode;
}({});

//# sourceMappingURL=timed-data-gatherer.enums.js.map